import { AnyRoute, createFileRoute, LoaderFnContext, redirect } from '@tanstack/react-router';
import { decode } from 'js-base64';
import { z } from 'zod';
import { RouterContext } from '@mews-commander/modules';
import { authenticateWithSecondFactor, DEVICE_AUTH_REQUIRED } from '@mews-commander/modules/src/modules/auth';
import { MewsTeam, RouteType } from '@mews/enums';
import { lt, showErrorAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const redirectLoader = async ({
    params,
    context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch },
}: LoaderFnContext<AnyRoute, Record<'pin' | 'signInToken', string>, {}, {}, RouterContext>) => {
    const schema = z.object({
        pin: z.string().transform(decode),
        signInToken: z.string(),
    });

    try {
        const { pin, signInToken } = schema.parse(params);
        await dispatch(authenticateWithSecondFactor({ pin, signInToken, runPostSignInChecks: true }));
    } catch (error) {
        if (error.message !== DEVICE_AUTH_REQUIRED) {
            showErrorAlert({
                description: lt('TwoFactorAuthenticationEmailExpiredLinkError'),
                title: lt('LinkExpired'),
            });
            throw redirect({ to: '/Home/SignIn' });
        }
    }
};

export const Route = createFileRoute('/_public/Home/Redirect/$pin/$signInToken')({
    loader: redirectLoader,
    staticData: {
        title: TextKey.SignIn,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
